import { LitheRoutes } from 'lithejs-router/dist/index.model';

import HomePage from '../pages/home';
import TutorialPage from '../pages/tutorial';
import DocsPage from '../pages/docs';
import ExamplesPage from '../pages/examples';
import ExamplePage from '../pages/examples/example';
import BlogPage from '../pages/blog';
import PostPage from '../pages/post';

export const routes = [
  {
    path: '',
    component: () => HomePage({ id: 'home-page' }),
    routes: [
      {
        path: 'docs',
        component: () => DocsPage({ id: 'docs-page' }),
        routes: [
          {
            path: '[section]',
            component: () => DocsPage({ id: 'docs-page' }),
          },
        ],
      },
      {
        path: 'tutorial',
        component: () => TutorialPage({ id: 'tutorial-page' }),
        routes: [
          {
            path: '[section]',
            component: () => TutorialPage({ id: 'tutorial-page' }),
          },
        ],
      },
      {
        path: 'examples',
        component: () => ExamplesPage({ id: 'examples-page' }),
        routes: [
          {
            path: '[example]',
            component: () => ExamplePage({ id: 'example-page' }),
          },
        ],
      },
      {
        path: 'blog',
        component: () => BlogPage({ id: 'blog-page' }),
        routes: [
          { path: '[slug]', component: () => PostPage({ id: 'post-page' }) },
        ],
      },
    ],
  },
] satisfies LitheRoutes;
